module.exports = __webpack_public_path__ + "img/substation.6cf07a6c.png";